import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { MessageField } from '@/@vxapp/@Enums/PHP/ServicesV2/Messages/DataProviders/MessageField'

export const MessagesTableActions = [
  {
    id: 'preview',
    title: 'Preview',
    tooltip: 'Preview Message',
    icon: 'tabler-eye',
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Messages.Preview.Name || '',
      paramKey: 'guid',
      itemKey: MessageField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
  {
    id: 'send',
    title: 'Send',
    tooltip: 'Send Message',
    icon: 'tabler-send',
    color: 'success',
    disabled: false,
    hidden: false,
    emit: 'send',
  },
] as const satisfies readonly TableActionSpec[]
